<div class="flex flex-row">
  <img class="w-[1rem] text-gold-500" alt="" [src]="iconPath" />
  <div class="ml-2xs">{{ label }}</div>
</div>
